"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalLink = exports.Link = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = _styledComponents.default.a.withConfig({
  displayName: "Link",
  componentId: "sc-14lgydv-0"
})(["color:#1173bb;text-decoration:none;&:visited,&:active{color:#1173bb;}&:focus,&:hover{text-decoration:underline;}"]);

exports.Link = Link;
var ExternalLink = (0, _styledComponents.default)(Link).attrs({
  rel: 'noopener noreferrer',
  target: '_blank'
}).withConfig({
  displayName: "Link__ExternalLink",
  componentId: "sc-14lgydv-1"
})([""]);
exports.ExternalLink = ExternalLink;